import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineSmallButton, PrimaryButton,} from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_SMALL_OUTLINE_BUTTONS, RAISED_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedOutlineSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineSmallButton} span={RAISED_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="sm" outline color="primary" id="Tooltip-61" className="btn-pill btn-air-primary">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-61" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-air-primary btn-sm</ToolTip>
          {RAISED_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} outline size="sm"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedOutlineSmallButtons;
